/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_1b5f9387"]'><cube-tab-bar :value="selectedLabelSlotsOnly" mpxModelEvent="input" @_click="clickHandler" custom-content :tabs="(tabs)" @mpxModel='(e)=>__invoke(e, [["__model","selectedLabelSlotsOnly", "__mpx_event__", ["value"], undefined]])' @change='(e)=>__invoke(e, [["changeHandler"]])'><cube-tab v-for="(item, index) in (tabs)" :key="item.label" :label="(item.label)" :value="(item.value)" custom-content custom-icon :class='["cube-tab"]'><cube-icon :type="(item.icon)"/><span></span></cube-tab></cube-tab-bar></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_1b5f9387"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_1b5f9387"}
  /** script content **/
  require("./tab-bar-slot.mpx.js?isComponent&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./tab-bar-slot.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Ftab-bar-slot1b5f9387%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_1b5f9387"],
    ctorType: "component",
    outputPath: "components/tab-bar-slot1b5f9387/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-tab-bar':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/index.mpx?isComponent&outputPath=components%2Findexff7d3170%2Findex")),'cube-tab':getComponent(require("../../../packages/mpx-cube-ui/src/components/tab-bar/tab.mpx?isComponent&outputPath=components%2Ftab66c6e44b%2Findex")),'cube-icon':getComponent(require("../../../packages/mpx-cube-ui/src/components/icon/index.mpx?isComponent&outputPath=components%2Findex1d853680%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>